@if (!!title?.length) {
<atx-modal-header (dismiss)="modal.close()">
  {{ title }}
</atx-modal-header>
}
<atx-modal-body>
  {{ message }}
</atx-modal-body>
<atx-modal-footer>
  @for (choice of choices; track choice; let i = $index) {
  <button
    class="btn"
    [ngClass]="choice.isPrimary ? 'btn-primary' : 'btn-light'"
    [class.mr-2]="i !== choices.length - 1"
    (click)="answer(choice)"
  >
    {{ choice.label }}
  </button>
  }
</atx-modal-footer>
